<template>
    <Modal
            v-model="showModal"
            title="报名清单"
            :loading="true"
            :footer-hide="true"
            :styles="{top: '20px',width:'1100px',height:'500px'}"
    >
        <Table :columns="columns" :data="data" :loading="dataLoading"></Table>
    </Modal>
</template>

<script>
    export default {
        name: 'record-form',
        data() {
            return {
                columns: [
                    {
                        title: '姓名',
                        key: 'name'
                    },
                    {
                        title: '电话',
                        key: 'mobile'
                    },
                    {
                        title: '预约时间',
                        key: 'createtime'
                    }
                ],
                data: [],
                dataLoading: false,
                showModal:false
            }
        },
        methods:{
            showWin(id){
                let self = this;
                self.dataLoading = true;
                this.$api.signup.getRecordList({id:id}).then(resp=>{
                    self.data = resp.data;
                    self.dataLoading = false;
                });
                self.showModal = true;
            }
        }
    }
</script>
